// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"AddButton_ProseMirror__sD_zO","btnAdd__icon":"AddButton_btnAdd__icon__8d5qZ","rotate-shadow":"AddButton_rotate-shadow__17Ytg"};